import {Component, createRef} from "preact";
type FileDropAreaProps = {
    handleDrop: (files: FileList) => void;
    style?: any;
};
export class FileDropArea extends Component<FileDropAreaProps> {
    private dropRef = createRef();
    private dragCounter = 0;

    handleDrag = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
    };
    handleDragIn = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter++;
        if (e.dataTransfer?.items && e.dataTransfer.items.length > 0) {
            this.setState({drag: true});
        }
    };
    handleDragOut = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.setState({drag: false});
        }
    };
    handleDrop = (e: DragEvent) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({drag: false});
        if (e.dataTransfer?.files && e.dataTransfer.files.length > 0) {
            this.props.handleDrop(e.dataTransfer.files);
            e.dataTransfer.clearData();
            this.dragCounter = 0;
        }
    };
    componentDidMount() {
        let div = this.dropRef.current;
        div.addEventListener("dragenter", this.handleDragIn);
        div.addEventListener("dragleave", this.handleDragOut);
        div.addEventListener("dragover", this.handleDrag);
        div.addEventListener("drop", this.handleDrop);
    }
    componentWillUnmount() {
        let div = this.dropRef.current;
        div.removeEventListener("dragenter", this.handleDragIn);
        div.removeEventListener("dragleave", this.handleDragOut);
        div.removeEventListener("dragover", this.handleDrag);
        div.removeEventListener("drop", this.handleDrop);
    }
    render() {
        return (
            <div
                style={{
                    border: " 2px dotted gray",
                    color: "white",
                    padding: "10px",
                    borderRadius: "5px",
                    ...this.props.style
                }}
                ref={this.dropRef}
            >
                Drop *.svg file here
            </div>
        );
    }
}
